import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import Loading from "../../shared/component/others/Loading";
import DataTable from "../../shared/component/dataTable/DataTable";
import SaleReportColumn from "../../shared/component/dataTable/columns/SaleReportColumn.json";
import {Button} from "reactstrap";
import Translate from "../../shared/language/Translate";
import './SaleReportPage.css';
import '../../shared/styles/SettingsPage.css';

export default class SaleReportMergeDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            saleReportList: [],
            loading: false
        };
    }

    componentDidMount() {
    }


    render() {
        return (
            <div className="sale-report-page__dialog">
                <AvForm>
                    {this.renderReport()}
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }


    renderReport() {
        return (
            <div>
                <div className="sale-report-page__table-wrap sale-report-page__report-table">
                    <DataTable
                        fields={SaleReportColumn.fields}
                        ref={(elem) => this.refDataTable = elem}
                        objectName={SaleReportColumn.name}
                        rows={100}
                        reportName="Sale Report"
                        data={this.state.saleReportList}
                        paginator={false}
                        selectionMode="single"
                        loading={this.state.loading}/>
                </div>

                <div className="sale-report-page__dialog-footer settings-page__actions settings-page__actions--inline">
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--cancel settings-page__btn--close"
                        onClick={() => this.props.closeDisplayDialog()}>
                        <Translate contentKey="entity.action.cancel">Close</Translate>
                    </Button>
                </div>
            </div>
        );
    }

    setData = (data) => {

        this.setState({
            saleReportList: data
        }, () => {
            this.refDataTable.refresh();
        });

    }

}
